import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../grid-container/GridContainer"
import FooterLogo from "../../../../styles/img/sherbet-footer-logo.png"
import UiEmailSubscribe from "../form/UiEmailSubscribe"
import { UiButtonPrimary } from "../form/UiButton"
import FooterFbIcon from "../../../../styles/img/svg/FooterFbIcon"
import FooterLinkedinIcon from '../../../../styles/img/svg/FooterLinkedinIcon'
import FooterTwitterIcon from '../../../../styles/img/svg/FooterTwitter'
import {
    UiFooterWr,
    UiFooterLeftCol,
    UiFooterEmailSubscribe,
    UiFooterContacts,
    UiFooterSocialMedia,
    UiFooterCopyRights,
    UiFooterNavWr,
    UiFooterNavTitle,
    UiFooterNavItem,
    UiFooterTop
} from './UiFooterElements'
import { YoutubeIcon } from '../../../../styles/img/svg/YoutubeIcon'
import { TwitterIcon } from '../../../../styles/img/svg/TwitterIcon'
import { VimeoIcon } from '../../../../styles/img/svg/VimeoIcon'

export default function Footer(props) {

    return (
        <>
            <UiFooterTop />
            <UiFooterWr>
                <UiRowContainer>
                    <div className='sb-footer-subscribe'>
                        <h4>With Sherbet, earn more with <br />loyalty points today</h4>
                        <UiFooterEmailSubscribe>
                            <UiButtonPrimary btnName="Subscribe Now" size="56" />
                        </UiFooterEmailSubscribe>
                    </div>
                </UiRowContainer>

                <UiRowContainer>
                    <UiCol lg="9" className="sb-footer-menu">
                        <UiFooterNavWr>
                            <UiFooterNavItem item="Points" />
                            <UiFooterNavItem item="Why Sherbet" />
                            <UiFooterNavItem item="Reviews" />
                            <UiFooterNavItem item="Help" />
                        </UiFooterNavWr>
                    </UiCol>
                    <UiCol lg="3">
                        <div className='sb-social-icon'>
                            <a><FooterFbIcon /> </a>
                            <a><TwitterIcon /></a>
                            <a><VimeoIcon /></a>
                            <a><YoutubeIcon /></a>
                        </div>
                    </UiCol>
                    <div className="sb-footer-bottom ">
                        <UiCol lg="4">
                            <UiFooterContacts email="email@gmail.com" tel="000 1234 5678" />
                        </UiCol>
                        <UiCol lg="4" className="sb-footer-logo">
                            <img src={FooterLogo} />
                        </UiCol>
                        <UiCol lg="4" className="sb-footer-tns">
                            <a>Terms of service</a>
                            <a>Privacy Policy</a>
                            <h5>© 2023 ABC. All rights reserved.</h5>
                        </UiCol>
                    </div>

                </UiRowContainer>
            </UiFooterWr>

        </>
    )
}
